











import { Component, Vue } from "vue-property-decorator";
import { getUserJson } from "@/req/homes";
@Component({
  components: {},
})
export default class Home extends Vue {
  public content: any = "";
}
